/**
 * 任务指派主路由
 * 2019-05-08
 * Qian.qianchen
 */
"use strict";
angular.module("taskAssignmentRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.
    state("front.plan.taskassignment.assignments", { //任务指令
        url: '/assignments',
        views: {
            "main@front.plan.taskassignment": {
                template: "<div ui-view='main'></div>"
            }
        }
    }).
    state("front.plan.taskassignment.myassignments", { //我的任务
        url: '/myassignments',
        views: {
            "main@front.plan.taskassignment": {
                template: "<div ui-view='main'></div>"
            }
        }
    });
}]);